import React from "react";
import "./ScanQRCode.scss";
import scan from "./images/test-scan.svg";
import http from "../../util/api";
import { Toast } from "antd-mobile";
import moment from "moment";
import withAuth from "../../HOCs/withAuth";
import { getItem } from "../../util/util";
import GoBack from "../../components/GoBack";
import axios from "axios";

const resid1 = "617193728135"; //批次签到控制表
const resid2 = "617396548838"; //批次签到记录表
const seconds = 60;
class ScanQRCode extends React.Component {
  state = {
    isScanning: false,
    userCode: JSON.parse(getItem("userInfo")).UserCode
  };

  async componentDidMount() {
    window.V5CHAT("hideBtn");
    await this.getWXConfig();
  }

  getWXConfig = async () => {
    try {
      let url;
      let u = navigator.userAgent;
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid) {
        url = window.location.href;
      } else if (isiOS) {
        url = window.wx_js_url || window.location.href;
      }
      let res = await axios.get(
        "http://kingofdinner.realsun.me:1201/api/wx/GetSignature",
        {
          params: {
            requesturl: url
          }
        }
      );
      if (res.data.error === 0) {
        let { data } = res.data;
        await window.wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.AppId, // 必填，公众号的唯一标识
          timestamp: data.Timestamp, // 必填，生成签名的时间戳
          nonceStr: data.NonceStr, // 必填，生成签名的随机串
          signature: data.Signature, // 必填，签名，见附录1
          jsApiList: ["scanQRCode"] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
        window.wx.ready(res => {
          console.log("ready", res);
        });
        window.wx.error(res => {
          console.log("调用微信jsapi返回的状态:", res.errMsg);
        });
      } else {
        console.error("error:  " + res.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  addRecord = async id => {
    try {
      let res = await http().addRecords({
        resid: resid2,
        data: [{ testBatchId: id, C3_617914885014: this.state.userCode }],
        isEditOrAdd: true
      });
      let data = res.data;
      if (data.Error === 0 || data.error === 0) {
        if (data.data.length) {
          sessionStorage.setItem("batchId", data.data[0].batchId);
          sessionStorage.setItem("testBatchId", id);
          if (!data.data[0].batchId) {
            return Toast.fail("考试批次为空");
          }
          this.props.history.push("/start_test", {
            batchId: data.data[0].batchId,
            testBatchId: id
          });
        } else {
          Toast.fail("无数据");
        }
      } else {
        Toast.fail(data.message);
      }
    } catch (error) {
      console.log(error);
      Toast.fail(error.message);
    }
    Toast.hide();
  };

  //获取签到状态，判断是否能够签到
  getStatus = async id => {
    Toast.loading("签到中,请稍后...", 0);
    try {
      let res = await http().getTable({
        resid: resid1,
        cmswhere: `testBatchId = ${id}`
      });
      let data = res.data;
      if (data.error === 0) {
        if (data.data.length) {
          if (data.data[0].Checkstatus === "签到中") {
            await this.addRecord(id);
          } else {
            Toast.fail("签到已停止");
          }
        } else {
          Toast.fail("无效的二维码");
        }
      } else {
        Toast.fail(data.message);
        console.log(res.data.message);
      }
    } catch (error) {
      console.log(error);
      Toast.fail(error.data.message);
    }
  };

  goBack = () => this.props.history.push("/home");

  render() {
    return (
      <div className="scan_qrcode">
        <GoBack goBack={this.goBack} />
        <div className="content">
          <div className="content_main">
            <div className="finisar_logo" />
            <div className="scanning_wraper">
              <div
                className="scanning"
                onClick={async () => {
                  window.wx.scanQRCode({
                    desc: "scanQRCode desc",
                    needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                    scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
                    success: async res => {
                      let result = res.resultStr;
                      result = result.split("+");
                      if (result[1]) {
                        if (moment().unix() - result[1] < seconds) {
                          await this.getStatus(result[0]);
                        } else {
                          Toast.fail("二维码已过期，请重新扫描");
                        }
                      } else {
                        Toast.fail("无效二维码");
                      }
                    },
                    error: function(err) {
                      alert("错误" + err);
                      if (err.errMsg.indexOf("function_not_exist") > 0) {
                        alert("版本过低请升级");
                      }
                    }
                  });
                }}
              >
                <img
                  style={{ width: "4.5rem", height: "4.5rem" }}
                  src={scan}
                  alt="logo"
                />
              </div>
            </div>
          </div>
          <footer>
            <p>考试即将开始</p>
            <p>请扫描考试现场的二维码签到</p>
          </footer>
        </div>
      </div>
    );
  }
}

export default withAuth(ScanQRCode);
